export default __webpack_public_path__ + "static/media/arrowBackHsb.1ca78840.svg";